import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Button as AntdButton } from 'antd';

import styles from './button.module.scss';

const Button = forwardRef(({
	children,
	type,
	size,
	disabled,
	loading,
	onClick,
	htmlType,
	color,
	style,
	id,
	icon,
}, ref) => {
	return (
		<>
			{type === 'bordered' ? (
				<AntdButton
					ref={ref}
					size={size}
					disabled={disabled}
					loading={loading}
					onClick={onClick}
					htmlType={htmlType}
					style={style}
					id={id}
					icon={icon}
					className={`${styles['border-button']} ${
						styles[`border-btn-${color}`]
					}`}
				>
					{children}
				</AntdButton>
			) : type === 'xs' ? (
				<AntdButton
					ref={ref}
					size={size}
					disabled={disabled}
					loading={loading}
					onClick={onClick}
					htmlType={htmlType}
					id={id}
					style={style}
					icon={icon}
					className={`${styles['button-xs']} ${styles[`btn-${color}`]}`}
				>
					{children}
				</AntdButton>
			) : (
				<AntdButton
					ref={ref}
					size={size}
					disabled={disabled}
					loading={loading}
					onClick={onClick}
					htmlType={htmlType}
					id={id}
					style={style}
					icon={icon}
					className={`${styles['button']} ${styles[`btn-${color}`]}`}
				>
					{children}
				</AntdButton>
			)}
		</>
	);
});

Button.displayName = 'Button';

Button.defaultProps = {
	color: 'dark',
};

Button.propTypes = {
	children: PropTypes.node.isRequired,
	color: PropTypes.string,
};

export default Button;
